<form class="form" [formGroup]="uploadDocumentForm" (ngSubmit)="onSubmit()">
  <div *ngIf="previousDocument">
      Previously uploaded document found. NBRC has been notified and document will be reviewed as soon as possible. If you upload a new document it will replace
      the previously uplaoded document: <strong>{{previousDocument.fileName}}</strong> Uploaded on: <strong>{{previousDocument.uploadDate | amDateFormat: 'MM/DD/YYYY'}}</strong>
  </div>
	<fieldset class="form-section">
		<legend class="legend">Upload Document for Audit</legend>
      	<div class="field">
	      <div class="field__label-input-wrap">
          	<label for="File" class="label">Document:</label>
        <input class="input input--large" type="file" id="File" (change)="updateFile($event)" [class.input--invalid]="formErrors.File" formControlName="File" >
			  <div *ngIf="formErrors.File" class="error-message field__error-message">{{ formErrors.File }}</div>
			  <p>File must be PDF, DOC or DOCX</p>
	      </div>
      </div>
		<div class="form-actions">
      <input class="button form-actions__item" type="submit" value="Upload" />
      <!-- <input class="button form-actions__item" type="submit" value="Upload & Add Another" (click)="SaveAndAdd=true" /> -->
			<button (click)="onCancel($event)" class="button button--secondary form-actions__item">Cancel</button>
		</div>
		<div *ngIf="formLevelErrors" class="error-message field__error-message">
            <p *ngFor="let error of formLevelErrors">{{error}}</p>
        </div>
	</fieldset>
</form>
